import { render } from "./App.vue?vue&type=template&id=84f9ea44"
const script = {}

import "./App.vue?vue&type=style&index=0&id=84f9ea44&lang=css"

import exportComponent from "/Users/dave/Development/projects/te2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__